<template>
  <li class="content-box reporting__cta__rank-list-item" v-if="item.coords">
    <div class="title">
      <strong>
        <span class="rank">{{ index + 1 | rank }}.</span>
        <span class="value"> {{ item.value | thousand }} {{ getClicksLabel }}</span>
      </strong>
      <span class="bar">|</span>
      <span class="percentage"><strong>{{ item.clickPercentage | fixed(2) }}%</strong> of all {{ getClicksLabel }}</span>
    </div>
    <div class="item-content clearfix">
      <div class="rank-list-item__element-info" @click="$emit('onThumbnailClick', item)">
        <div class="rank-list-item__element-img">
          <div class="element-img--wrap">
            <crop-image :url="imageData.url"
                        :imageWidth="imageData.width"
                        :imageHeight="imageData.height"
                        :width="item.coords.width"
                        :height="item.coords.height"
                        :maxWidth="114"
                        :maxHeight="100"
                        :offset="{ x: item.coords.left, y: item.coords.top }"/>
          </div>
          <p class="element-img-size">
            {{ item.coords.width | round | thousand }} x
            {{ item.coords.height | round | thousand }} (px)
          </p>
          <div class="rank-list-item__element-detail">
            <ul>
              <li></li>
            </ul>
          </div>
          <div class="hover_mark icon--crosshair-mark"></div>
        </div>
      </div>
      <div class="rank-list-item__element-analysis clearfix" >
        <ul>
          <li v-if="isDesktopDevice" class="clearfix">
            <span class="title-wrap">
              <ui-icon-tooltip><span v-html="$t('common.reportIndicator.hovers.tooltip')"></span></ui-icon-tooltip>
              <span class="title">Hovers</span>
            </span>
            <span class="value">{{ item.coords.hoverCount | thousand }} {{ $t('common.unit.cnt') }}</span>
          </li>
          <li class="clearfix">
            <span class="title-wrap">
              <ui-icon-tooltip>
                <span v-if="bNewMobile" v-html="$t('common.reportIndicator.tapRate.tooltip')"></span>
                <span v-else v-html="$t('common.reportIndicator.clickRate.tooltip')"></span>
              </ui-icon-tooltip>
              <span class="title">{{ getClickInfoLabel }} Rate</span>
            </span>
            <span class="value">{{ item.coords.clickRate | fixed(1) }} %</span>
          </li>
          <li class="clearfix">
            <span class="title-wrap">
              <ui-icon-tooltip>
                <span v-if="bNewMobile" v-html="$t('common.reportIndicator.tapPvRate.tooltip')"></span>
                <span v-else v-html="$t('common.reportIndicator.clickPvRate.tooltip')"></span>
              </ui-icon-tooltip>
              <span class="title">{{ getClickInfoLabel }} PV Rate</span>
            </span>
            <span class="value">{{ item.coords.clickPvRate | fixed(1) }} %</span>
          </li>
        </ul>
      </div>
      <ui-button class="analyze" size="small"
                 @click="$emit('onCtaCoordsClick', item.coords)">Analyze</ui-button>
    </div>
  </li>
</template>

<script>
import CropImage from '@/components/ui/CropImage'
import UiButton from '@/components/ui/UiButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import { NEW_MOBILE_HEATMAP_STARTDATE } from '@/libs/constants'

export default {
  name: 'RankItem',
  components: {
    CropImage,
    UiButton,
    UiIconTooltip
  },
  props: [
    'type',
    'index',
    'item',
    'imageData',
    'isDesktopDevice',
    'reportPeriod',
    'applyData'
  ],
  computed: {
    bNewMobile () {
      let bAMP = this.applyData.bAMP
      let bNewMobile = true
      if ((this.reportPeriod.start < NEW_MOBILE_HEATMAP_STARTDATE) || bAMP || this.isDesktopDevice) {
        bNewMobile = false
      }
      return bNewMobile
    },
    getClicksLabel () {
      return this.bNewMobile ? 'Taps' : 'Clicks'
    },
    getClickInfoLabel () {
      return this.bNewMobile ? 'Tap' : 'Click'
    }
  }
}
</script>

<style lang="scss" scoped>
.reporting__cta__rank-list-item {
  margin-top: 30px;

  .title {
    strong {
      font-size: 15px;
      font-weight: bold;
      .rank {
        color: #2f2f2f;
      }
      .value {
        color: $brandColor;
      }
    }
    .bar {
      position: relative;
      top: -1px;
      display: inline-block;
      color: #d8d8d8;
      width: 1px;
      height: 12px;
      margin: 0 8px;
    }
    .percentage {
      font-size: 14px;
      color: #2f2f2f;
      strong {
        font-size: 14px;
        font-weight: normal;
        color: $brandColor;
      }
    }
  }

  .item-content {
    position: relative;
    margin-top: 13px;
  }

  .rank-list-item__element-info {
    float: left;
    width: calc(100% - 190px);
    height: 130px;
    box-sizing: border-box;
    border-radius: 6px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    color: #666666;
    cursor: pointer;

    .rank-list-item__element-img {
      margin: 8px;
      position: relative;
      height: 100px;
      box-sizing: border-box;

      .element-img--wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
        }
      }
      .element-img-size {
        position: absolute;
        width: 100%;
        bottom: 0;
        margin-bottom: -16px;
        text-align: center;
        font-size: 12px;
        color: #2f2f2f;
      }
    }

    .hover_mark {
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -50%);
      display: none;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      transition: all 0.2s ease-in;

      .hover_mark {
        display: block;
      }

      .element-img--wrap::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        transition: all 0.2s ease-in;
      }
    }
  }

  .rank-list-item__element-analysis{
    width: 190px;
    padding-left: 20px;
    box-sizing: border-box;
    float: right;

    ul{
      li {
        margin-top: 10px;
        font-size: 13px;
        .title-wrap {
          float: left;
          .title {
            margin-left: 4px;
            color: #666666;
          }
        }
        .value {
          color: #2f2f2f;
          float: right;
        }
      }
    }
  }

  .analyze {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 90px;
  }

  .rank-list-item__element-chart {
    margin-top: 18px;
  }
}
@media screen and (min-width: 1856px) {
  li.content-box.reporting__cta__rank-list-item {
    display: inline-block;
    width: calc(50% - 15px);

    &:nth-child(2n-1) {
      margin-right: 30px;
    }
  }
}
</style>
